import { render, staticRenderFns } from "./BoxesByPartner.vue?vue&type=template&id=4cf8207f&scoped=true&"
import script from "./BoxesByPartner.vue?vue&type=script&lang=js&"
export * from "./BoxesByPartner.vue?vue&type=script&lang=js&"
import style0 from "./BoxesByPartner.vue?vue&type=style&index=0&id=4cf8207f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf8207f",
  null
  
)

export default component.exports